import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import Sidenav from "layouts/pages/account/settings/components/Sidenav";

import Header from "layouts/pages/account/settings/components/Header";

export default function AccountSettings() {
    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} lg={3}>
                    <Sidenav />
                </Grid>

                <Grid item xs={12} lg={9}>
                    <MDBox mb={3}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Header />
                            </Grid>
                        </Grid>
                    </MDBox>
                </Grid>
            </Grid>
        </MDBox>
    )
}